// extracted by mini-css-extract-plugin
module.exports = {"deletedUrlLabel":"_2304TSh_"};